import axios from 'axios'
import config from '@/config'

const client = axios.create(config.orrm.restapi)

export default client
